import Request from '@/utils/request';

export default async (ids) => {
  const params = {
    stids: ids,
    sensorvars: 1,
    // vars: variables.map(p => p.name).join(','),
    // county: 'tulare,fresno,madera,mariposa,tuolomne,alpine,mono,inyo',
    // state: 'ca',
  };

  const response = await Request.get('/stations/metadata', {
    params,
  });

  return response.data;
};



// WEBPACK FOOTER //
// ./src/api/getStationMetadata.js